'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('event-reservation-edit', {
      url: '/event-reservation/:type/edit/:id',
      template: '<event-reservation-edit></event-reservation-edit>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/reservation/event/edit/event-reservation-edit.routes.js